﻿(function ($, document) {

    $(document).ready(function () {
        $(document).ready(function () {
            $(document).on('change keypress', '.js-gift-message', function (e) {
                var $checkbox = $('.js-gift-message-checkbox input');
                if ($(this).val().length > 0) {
                    $checkbox.prop('checked', true);
                    $checkbox.attr('checked', true);
                }
            });
        });
    });


})(jQuery, document);